import axios from "vue-app/utils/axios";
import { DTOBillingDetailsResponse, DTOBillingUnitsChartResponse } from "vue-app/api/dto";

export const getBillingDetails = async (): Promise<DTOBillingDetailsResponse> => {
  const response = await axios.get<DTOBillingDetailsResponse>("/billing/details");
  return response.data;
};

export const getBillingChart = async (days: 30 | 90 | 180 | 365) => {
  const response = await axios.get<DTOBillingUnitsChartResponse>(`/billing/chart?days=${days}`);
  return response.data;
};

export const getStripeSession = async (): Promise<{
  response: {
    url: string;
    rejectReason: string;
  };
}> => {
  const { data } = await axios.get<{
    response: {
      url: string;
      rejectReason: string;
    };
  }>("/json/billing/createStripeSession");
  return data;
};
